import React from 'react'

const DashboardProfessionals = () => {
	return <div>DashboardProfessionals</div>
}

export default DashboardProfessionals
